import component from "containers/StaticPages/pages/Ambassador";

export default {
  key: "ambassador-join",
  title: "Create Ambassador Account",
  path: "/:user?/ambassador",
  pageName: "ambassador",
  linkTarget: "/ambassador",
  exact: true,
  component,
};
